import { render } from "./OfflinePage.vue?vue&type=template&id=5f3f1aa8&scoped=true"
import script from "./OfflinePage.vue?vue&type=script&lang=js"
export * from "./OfflinePage.vue?vue&type=script&lang=js"

import "./OfflinePage.vue?vue&type=style&index=0&id=5f3f1aa8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f3f1aa8"]])

export default __exports__